import moment from 'moment'

export default class Permissions {

    redirectToHome(to, from, next) {
        Vue.prototype.$auth.getMe(to, from, next, true)
        .then(() => {

            // Online home.
            if (!Vue.prototype.$auth.hasOnePermission([
                'xapi-extra.manage',
                'xapi-extra.observe',
            ])) {
                next({ name: 'my-statements' });
            } else {
                next()
            }

        })
        .catch(err => {
            next({ name: err });
        })
    }
}
